import type { VerificationButtonState } from '@/constants/check-verification.constants'

type Details =
  | { checkId?: number | null; hasCoordinates?: boolean; checkMethod?: string | null }
  | null
  | undefined

/** O relatório traz o método já traduzido ("Biometria"); a regra usa o rótulo. */
export function mapCheckVerification(d: Details): {
  checkId: number | null
  state: VerificationButtonState
} {
  if (!d?.checkId) return { checkId: null, state: 'NONE' }
  if (d.checkMethod === 'Biometria') return { checkId: d.checkId, state: 'BIOMETRY' }
  return { checkId: d.checkId, state: d.hasCoordinates ? 'LOCATION' : 'NONE' }
}
